<template>
  <HeroView
      title="Force"
      text="Sales-optimized dark theme with conversion-driven design and high-impact features — designed to maximize sales opportunities and accelerate revenue growth."
      purchase-link="https://themes.shopify.com/themes/force/presets/force"
      price="$380"
      img-main="/assets/imgs/themes/force/hero/hero@2x.webp"
      img-set="/assets/imgs/themes/force/hero/hero.webp 1x, /assets/imgs/themes/force/hero/hero@2x.webp 2x"
  />

  <DemosView
      title="5 Ready-Made <br>Profitable Layouts"
      text="Discover 5 effective layouts — engineered to enhance profitability and create high-impact customer experiences."
      theme-id="force"
  />
  <SubscribeSection theme="Force" :id="3"/>

  <BannerView
      title="Create a Commerce Space That Sparks Real Results"
      text="Sales-focused from start to finish — with converting popups, featured product highlights, bold animated headings, strict grids, translucent sections, and smooth animations, all designed to engage and convert."
      purchase-link="https://themes.shopify.com/themes/force/presets/force"
      price="$380"
      img-main="/assets/imgs/themes/force/banner@2x.webp"
      img-set="/assets/imgs/themes/force/banner.webp 1x, /assets/imgs/themes/force/banner@2x.webp 2x"
      dark-bg
  />
  <FeaturesView/>

  <SubscribeSection theme="Force" :id="1"/>
  <BuiltView/>
  <DocView
      docUrl="https://ashstonestudios.zendesk.com/hc/en-us/categories/33090690398994"
  />
  <SubscribeNewsletterView theme="Force" :id="2"/>
  <FinalView
      title="Achieve Higher Conversions with Force"
      text="Every feature is designed to increase conversions, drive sales, and maximize your growth potential."
      purchase-link="https://themes.shopify.com/themes/force/presets/force"
      price="$380"
      img-main="/assets/imgs/themes/force/final@2x.webp"
      img-set="/assets/imgs/themes/force/final.webp 1x, /assets/imgs/themes/force/final@2x.webp 2x"
  />
</template>

<script>
import HeroView from '@/components/general/HeroView.vue'
import DemosView from '@/components/general/DemosView.vue'
import BannerView from '@/components/general/BannerView.vue'
import FeaturesView from '@/components/general/FeaturesView.vue'
import BuiltView from '@/components/general/BuiltView.vue'
import DocView from '@/components/general/DocView.vue'
import FinalView from '@/components/general/FinalView.vue'

export default {
  name: 'ForceView',
  components: {
    HeroView,
    DemosView,
    BannerView,
    FeaturesView,
    BuiltView,
    DocView,
    FinalView
  }
}
</script>


<script setup>
import { useHead } from '@vueuse/head'
import SubscribeSection from "@/components/SubscribeSection.vue";
import SubscribeNewsletterView from "@/components/SubscribeNewsletterView.vue";

useHead({
  title: 'Force – Bold Dark-Style Shopify Theme ',
  meta: [
    { name: 'description', content: 'Bold dark Shopify theme with sales-optimized, conversion-driven design and high-impact features to boost revenue and maximize sales opportunities.' },

    { property: 'og:title', content: 'Force – Bold Dark-Style Shopify Theme for Sales-Driven Stores' },
    { property: 'og:description', content: 'Sales-optimized dark Shopify theme with bold design and conversion-driven features to maximize revenue and accelerate growth.' },
    { property: 'og:image', content: '/assets/imgs/themes/force/og_image.png' },
    { property: 'og:url', content: 'https://creativecommercelabs.com/themes/force' },
    { property: 'og:type', content: 'website' },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:site_name', content: 'Force' }
  ]
})
</script>
